import { UpsellTypes } from 'models/Basket';
import { formatCurrency } from 'formatters';

export interface UpsellContentItem {
    id: UpsellTypes;
    title: string;
    subtitle: string;
    text: string[];
    orderMessage: string;
    helpLink: UpsellHelpLink;
    logoImage: string;
    disabledSubtitle?: string;
    togglerDescription?: (qty: number) => string;
    togglerPrice?: (price: number) => string;
}

interface UpsellHelpLink {
    title: string;
    path: string;
}

export const upsellContentItems: UpsellContentItem[] = [
    {
        id: UpsellTypes.Sofashield,
        title: 'Sofashield Plus',
        subtitle: 'Relax without the worry.',
        text: [
            'Protect your new sofa against accidental staining and accidental damage plus cover for defects.',
            'With Sofashield Plus, you’ll have fast, effective, and professional help at hand.'
        ],
        orderMessage: 'Sofashield Plus added to your basket',
        helpLink: { title: 'Terms and conditions apply', path: 'https://www.sofology.co.uk/sofashield-terms' },
        logoImage: 'https://images.sofology.co.uk/b_rgb:fff,c_pad,q_100,fl_lossy,f_auto,h_150/Sofashield/sofashield_nsuhdh_1.png',
        disabledSubtitle: 'Sofashield Plus is currently unavailable in your region'
    },
    {
        id: UpsellTypes.LeatherCareKit,
        title: 'Leather Care Kit',
        subtitle: 'Specially formulated to keep your sofa looking its best.',
        text: [
            'Whether your sofa is leather or fabric, you’ll want to keep it looking its best day after day. Accidents and spills happen, but with quick action - and the right products - you can prevent staining so that you’ll continue to feel at home on a sofa you love.',
            'Our specially formulated care kits have everything you need to clean your sofa, whilst protecting the upholstery.',
            'Read help guidelines'
        ],
        orderMessage: 'Care Kit added to your basket',
        helpLink: { title: 'How do I use the Leather Care Kit', path: 'http://help.sofology.co.uk/en/articles/2058721-how-do-i-use-the-leather-care-kit' },
        logoImage: 'https://images.sofology.co.uk/b_rgb:fff,c_pad,q_100,fl_lossy,f_auto,h_150//ecom/carekit.jpg',
        togglerDescription: (qty: number) => `${qty}x Leather Programme`,
        togglerPrice: (price: number) => `${formatCurrency(price, 0)}`
    },
    {
        id: UpsellTypes.FabricCareKit,
        title: 'Fabric Care Kit',
        subtitle: 'Specially formulated to keep your sofa looking its best.',
        text: [
            'Whether your sofa is leather or fabric, you’ll want to keep it looking its best day after day. Accidents and spills happen, but with quick action - and the right products - you can prevent staining so that you’ll continue to feel at home on a sofa you love.',
            'Our specially formulated care kits have everything you need to clean your sofa, whilst protecting the upholstery.',
            'Read help guidelines'
        ],
        orderMessage: 'Care Kit added to your basket',
        helpLink: { title: 'How do I use the Fabric Care Kit', path: 'http://help.sofology.co.uk/en/articles/2057957-how-do-i-use-the-care-kit-to-clean-the-fabric' },
        logoImage: 'https://images.sofology.co.uk/b_rgb:fff,c_pad,q_100,fl_lossy,f_auto,h_150//ecom/carekit.jpg',
        togglerDescription: (qty: number) => `${qty}x Fabric Programme`,
        togglerPrice: (price: number) => `${formatCurrency(price, 0)}`
    },
    {
        id: UpsellTypes.Sofaglide,
        title: 'Sofaglide',
        subtitle: 'Heavy sofa? Slide it out of the way when cleaning.',
        text: [
            'Slide, clean and relax...',
            'Designed to work on carpet, wood or other flooring, adding Sofaglide to the feet of your sofa means it’ll effortlessly slide across your floor when you want it to - but only when you want it to.',
            'If you choose to add Sofaglide to your order, our delivery drivers will fit them to the feet of your furniture before they leave, so you can concentrate on relaxing and feeling at home on a sofa you love.'
        ],
        orderMessage: 'Sofaglide added to your basket',
        helpLink: { title: 'Read more', path: 'https://www.sofology.co.uk/sofology/sofaglide' },
        logoImage: 'https://images.sofology.co.uk/image/upload/c_scale/h_150/v1566202282/Sofaglide_Blk_kbbvss.png'
    },
    {
        id: UpsellTypes.SofaRescue,
        title: 'SofaRescue',
        subtitle: 'Sustainable, responsible sofa collection.',
        text: [
            'Working with our partners Clearabee we can remove your old sofa and dispose of it responsibly. We’ll take it to one of our approved disposal centres where as much of your sofa as possible will be recycled.',
            'Thousands of sofas each year end up in landfill. Choosing SofaRescue helps to divert your sofa from landfill, protecting the environment.'
        ],
        orderMessage: 'SofaRescue added to your basket',
        helpLink: { title: 'Read more', path: 'https://www.sofology.co.uk/responsibility/product/sofa-recycling' },
        logoImage: 'https://images.sofology.co.uk/b_rgb:fff,c_pad,q_100,fl_lossy,f_auto,h_150//v1583423350/sofarescue-logo-grey_xzybbc.png'
    }
];